<ta-flexbox
  justifyContent="space-around"
  alignItems="center"
  flexDirection="column"
  class="h--100 w--100 loading loading--large"
>
  <h1 class="heading--1">Logging you out...</h1>
  <div></div>
</ta-flexbox>
